import type {DataRouterDeletePagePayload} from '@github-ui/code-view-types'
import {mainQuery} from '@github-ui/react-core/future/main-query'

import {codeViewAppBuilder} from '../config/app-builder'

export const codeViewDeleteRoute = codeViewAppBuilder.createQueryRouteConfig('codeViewDeleteRoute', {
  path: '/:owner/:repo/delete/:branch/*',
  queries: [mainQuery<DataRouterDeletePagePayload>({encodeFetchPath: true})],
})
